<script setup>
    import Modal from '@/components/vue-components/bootstrap-components/Modal.vue';
    import ModalFooter from '@/components/vue-components/bootstrap-components/ModalFooter.vue';
    import { Modal as bsModal } from 'bootstrap';
    import { onMounted, onUnmounted, toRef, watch } from 'vue';
    import { trans } from 'laravel-vue-i18n';

    const props = defineProps({
        show: Boolean
    });
    const $t = trans;

    let modal = null;
    onMounted(() => {
        modal = new bsModal(document.getElementById('modal-rebuild-notification'));
    });
    onUnmounted(() => {
        modal.dispose();
    });

    function reloadPage() {
        window.location.reload();
    }
    const showRef = toRef(props, 'show');
    watch(showRef, (value) => {
        if (value) modal.show();
    });
</script>

<template>
    <form id="form-rebuild-notification" novalidate @submit="reloadPage">
        <modal
            id="modal-rebuild-notification"
            no-footer
            aria-labelledby="modal-rebuild-notificationLabel">
            <h4 id="modal-rebuild-notificationLabel">{{ $t('menus.modal.rebuild.title') }}</h4>
            <p>{{ $t('menus.modal.rebuild.description') }}</p>
            <template v-slot:footer>
                <modal-footer
                    :buttons="[
                        {
                            text: $t('menus.modal.rebuild.button'),
                            color: 'primary',
                            type: 'submit'
                        }
                    ]" />
            </template>
        </modal>
    </form>
</template>

<script>
    export default {
        name: 'RebuildNotification'
    };
</script>
